import React, { memo } from "react";
import { Routes as ReacrRoutesDom, Route } from "react-router-dom";
import Container from "../../pages/container";
import Login from "../../pages/login";




function Routes() {
    return (

        <ReacrRoutesDom>
            <Route exact path="/" element={<Container />} />
            <Route exact path="/users" element={<Container />} />
            <Route exact path="/create-user" element={<Container />} />
            <Route exact path="/coach" element={<Container />} />
            <Route exact path="/athlete" element={<Container />} />
            <Route exact path="/sport-list" element={<Container />} />
            <Route exact path="/categories-list" element={<Container />} />
            <Route exact path="/goals-list" element={<Container />} />
            <Route exact path="/equipments" element={<Container />} />
            <Route exact path="/sleep" element={<Container />} />
            <Route exact path="/sickness" element={<Container />} />
            <Route exact path="/skills" element={<Container />} />
            <Route exact path="/jobs" element={<Container />} />
            <Route exact path="/movements" element={<Container />} />
            <Route exact path="/packages" element={<Container />} />
            <Route exact path="/identification" element={<Container />} />
            <Route exact path="/movements/edit" element={<Container />} />
            <Route exact path="/movements/editMovements" element={<Container />} />
            <Route exact path="/inactions" element={<Container />} />
            <Route exact path="/requests" element={<Container />} />
            <Route exact path="/dashboard" element={<Container />} />
            <Route exact path="/notification" element={<Container />} />
            <Route exact path="/logout" element={<Container />} />
            <Route exact path="/transaction-list" element={<Container />} />
            <Route exact path="/transactions/wallet" element={<Container />} />

            <Route exact path="/login" element={<Login />} />
           
        </ReacrRoutesDom>

    );
}
export default memo(Routes);